@if (warningCodes().length > 0) {
  <button
    type="button"
    mat-icon-button
    class="plant-date-warning-indicator"
    [attr.aria-label]="warningSummary()"
    [matTooltip]="warningSummary()"
    matTooltipPosition="below"
  >
    <span aria-hidden="true" class="plant-date-warning__triangle">
      <span class="plant-date-warning__triangle-mark">!</span>
    </span>
  </button>
}
